import { render, staticRenderFns } from "./OrdersReport.vue?vue&type=template&id=0636a946&scoped=true&"
import script from "./OrdersReport.vue?vue&type=script&lang=js&"
export * from "./OrdersReport.vue?vue&type=script&lang=js&"
import style0 from "./OrdersReport.vue?vue&type=style&index=0&id=0636a946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0636a946",
  null
  
)

export default component.exports